import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 80vw;
	padding: 20px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		padding: 16px;
	}
`

export const HeaderSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 32px;
	max-width: 480px;
`

export const CardsGrid = styled.div`
	display: flex;
	justify-content: center;
	gap: 16px;
	width: 100%;
	max-width: 1080px;
	margin-bottom: 32px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: grid;
		grid-template-columns: 1fr;
	}
`

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 20px;
	border: 1px solid ${props => props.theme.colors.greys.border};
	border-radius: 12px;
	width: 360px;

		@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: auto;
		height: auto;
	}
`

export const CardInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 360px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
	}
`
